import { firestoreDateParser } from '@pedix-workspace/utils';
import { ProductStockMovement } from './stock.types';
import { withNestedConverter } from '@pedix-workspace/shared-models';

export const getProductStockMovementsConverter = withNestedConverter<ProductStockMovement>({
  fromFirestore(snapshot) {
    const movement = <ProductStockMovement>snapshot.data();

    return <ProductStockMovement>{
      ...movement,
      id: snapshot.id,
      created: firestoreDateParser(movement.created),
    };
  },
  toFirestore(movement: ProductStockMovement): ProductStockMovement {
    return movement;
  },
});
